import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';

function MenuLink({ name, link, subtitle }) {
	const StyledMenuList = styled.li`
		list-sytle: none;
		a.active {
			color: #cf004f;
			.adc & {
				color: #ef5f40;
			}
			.vir & {
				color: #d6083b;
			}
		}
	`;

	let classLink = `mb-12 d-block ${
		subtitle ? 'subtitle lower text-dark' : 'text-dark-medium'
	}`;

	return (
		<StyledMenuList>
			{link ? (
				<NavLink className={classLink} to={link}>
					{name}
				</NavLink>
			) : (
				<div className={classLink}>{name}</div>
			)}
		</StyledMenuList>
	);
}

export default MenuLink;
